export default __webpack_public_path__ + "static/media/AboutMe.3f27499b.png";